export const scrollToTopFromElement = (startEl: HTMLElement | null) => {
    if (typeof window === 'undefined') {
        return;
    }

    const isScrollable = (el: HTMLElement): boolean => {
        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;

        if (!['auto', 'scroll', 'overlay'].includes(overflowY)) {
            return false;
        }

        return el.scrollHeight > el.clientHeight;
    };

    let el: HTMLElement | null = startEl;
    while (el) {
        if (isScrollable(el)) {
            el.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        el = el.parentElement;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
};
